import { defineComponent as _defineComponent } from 'vue'
import { CdnImg } from '@webplatform/cdn-image';
import UiLink from './ui/UiLink.vue';

interface Props {
  data: {
    items: {
      url?: string | null;
      image: string;
      title: string;
      description: string;
      serviceForm?: boolean | null;
    }[];
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UserHelpCards',
  props: {
    data: null
  },
  emits: ["show-service-form"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'show-service-form'): void;
}), expose: any, slots: any, attrs: any }) {





function showServiceForm() {
  emit('show-service-form');
}

return { __sfc: true,emit, showServiceForm, CdnImg, UiLink }
}

})